import { Info, Camera, Video, DoorOpen, Star, MapPin, ArrowUpRight, Sparkles, Ruler, Tag } from "lucide-react";
import { asset } from "@/lib/api";

export const PIN_ICONS = { info: Info, camera: Camera, video: Video, door: DoorOpen, star: Star, pin: MapPin, link: ArrowUpRight, feature: Sparkles, size: Ruler, price: Tag };
export const PIN_STYLES = [["solid", "Solid"], ["ring", "Ring"], ["glass", "Glass"], ["pulse", "Pulse"]];

export function PinFace({ h }) {
  if (h.icon_url) return <img src={asset(h.icon_url)} alt="" className="w-full h-full object-contain pointer-events-none" draggable={false} />;
  const Icon = PIN_ICONS[h.icon] || Info;
  return <Icon className="w-5 h-5" />;
}

export function pinClass(h) {
  if (h.icon_url) return "w-12 h-12";
  const base = "w-10 h-10 rounded-full text-white shadow-xl";
  return {
    ring: `${base} border-[3px] bg-black/30 backdrop-blur-sm`,
    glass: `${base} bg-white/20 backdrop-blur-md border border-white/40`,
    pulse: `${base} tdv-pulse`,
  }[h.style] || base;
}

export function pinStyle(h) {
  if (h.icon_url) return {};
  const c = h.color || "var(--bp)";
  if (h.style === "ring") return { borderColor: c };
  if (h.style === "glass") return {};
  return { background: c, "--pulse": c };
}
